export function requiresChangesBeforeReview({
  requestedChangesAt,
  lastSubmittedAt,
}: {
  requestedChangesAt: Date | null
  lastSubmittedAt: Date
}): boolean {
  return requestedChangesAt != null && requestedChangesAt > lastSubmittedAt
}
